import { DESKTOP_MIN_BREAK_NUMBER } from '#/shared/constants';
import mapConfig from '#/map-config';

const initializedOnDesktop =
  typeof window !== 'undefined' &&
  window.innerWidth >= DESKTOP_MIN_BREAK_NUMBER;

const useInitialZoom = () => {
  const { mobile, desktop } = mapConfig.initZoom;
  return initializedOnDesktop ? desktop : mobile;
};

export default useInitialZoom;
